export interface UserAccount {
  id: number;
  user_id: number;
  total_invested_usd: number;
  total_claimed_yield_aero: number;
  bank_balance_usd: number;
  veaero_amount: number;
  created_at: string;
  updated_at: string;
}

export interface UserAccountResponse {
  account: UserAccount;
  timestamp: string;
}

export interface UpdateAccountRequest {
  total_invested_usd?: number;
  total_claimed_yield_aero?: number;
  bank_balance_usd?: number;
  veaero_amount?: number;
}

export interface UpdateAccountResponse {
  account: UserAccount;
  message: string;
  timestamp: string;
}

export async function fetchUserAccount(userId: number, isAdminAccess: boolean = false): Promise<UserAccountResponse> {
  const token = localStorage.getItem('authToken');
  const endpoint = isAdminAccess 
    ? `/api/users/${userId}/account`
    : `/api/users/${userId}/account/own`;
  
  const response = await fetch(endpoint, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  
  if (!response.ok) {
    throw new Error(`Failed to fetch user account: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
}

export async function updateUserAccount(userId: number, data: UpdateAccountRequest): Promise<UpdateAccountResponse> {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`/api/users/${userId}/account`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    throw new Error(`Failed to update user account: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
}
